module.exports = __webpack_public_path__ + "static/media/grey-checkbox.d541feb3.svg";